import App from './App';
import ReactDOM from 'react-dom';
import 'src/utils/chart';
import * as serviceWorker from './serviceWorker';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from 'src/redux/store';
import i18n from './utils/i18n';
import 'nprogress/nprogress.css';
import { ActionProvider } from './contexts/ActionContext';
import { I18nextProvider } from 'react-i18next';
ReactDOM.render(
  <Provider store={store}>
  <HelmetProvider>
    <ActionProvider>
      <BrowserRouter>
      <I18nextProvider i18n={i18n}>
        <App />
        </I18nextProvider>
      </BrowserRouter>
    </ActionProvider>
  </HelmetProvider>
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
